import { render, staticRenderFns } from "./Optimization.vue?vue&type=template&id=8dab3ca2&scoped=true"
import script from "./Optimization.vue?vue&type=script&lang=js"
export * from "./Optimization.vue?vue&type=script&lang=js"
import style0 from "./Optimization.vue?vue&type=style&index=0&id=8dab3ca2&prod&lang=scss"
import style1 from "./Optimization.vue?vue&type=style&index=1&id=8dab3ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dab3ca2",
  null
  
)

export default component.exports